<template>
  <el-dialog
    class="diglog-card"
    :title="$t('merchantAccount.repayment_details')"
    :visible.sync="dialogVisible"
    width="550px"
    :close-on-click-modal="false"
    @close="onClickCancelBtn"
  >
    <div class="repayment-info">
      <div class="repayment-info-item">
        <span class="text-lift">{{ $t('merchantAccount.amount_used') }}:</span>
        <span class="text-right">{{ repaymentInfo.unpaid_amount | toDivideWithDot }}</span>
      </div>
      <div class="repayment-info-item">
        <span class="text-lift">{{ $t('merchantAccount.service_fee') }}:</span>
        <span class="text-right">{{ repaymentInfo.unpaid_fee_amount | toDivideWithDot }}</span>
      </div>
      <div class="repayment-info-item">
        <span class="text-lift">{{ $t('merchantAccount.discount') }}:</span>
        <span class="text-right">{{ repaymentInfo.fee_exempt_amount | toDivideWithDot }}</span>
      </div>
      <div class="repayment-info-item">
        <span class="text-lift" style="font-weight: bold;">{{ $t('merchantAccount.total') }}:</span>
        <span class="text-right" style="font-weight: bold;">{{ repaymentInfo.total_amount | toDivideWithDot }}</span>
      </div>
      <div class="repayment-info-item">
        <span class="text-lift">{{ $t('merchantAccount.repayment_plan_amount') }}:</span>
        <div class="text-right">
          <el-input v-model="search.amount" size="small" style="width: 200px;" />
        </div>
      </div>
    </div>
    <div style="text-align: right; margin-top: 20px;">
      <el-button @click="onClickCancelBtn">{{ $t('components.cancel') }}</el-button>
      <el-button type="primary" :disabled="disabled" @click="onClickConfirmBtn">{{ $t('components.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'newContractModal',
  components: {
  },
  data() {
    return {
      search: {
        amount: null
      },
      repaymentInfo: {
        unpaid_amount: 0,
        unpaid_fee_amount: 0,
        fee_exempt_amount: 0,
        total_amount: 0,
        repay_time: null
      },
      disabled: false,
      dialogVisible: false,
      isLoading: false,
    }
  },
  computed: {

  },
  methods: {
    changModalStatus(value, row = {}) {
      this.dialogVisible = value
      this.repaymentInfo = row
    },
    onClickCancelBtn() {
      this.dialogVisible = false
    },
    onClickConfirmBtn() {
      this.$router.push({ name: 'Financial_Manage_Balance_Recharge', query: { amount: this.search.amount, name: 'NSDS_PAY' }})
    }
  }
}
</script>

<style lang="scss" scoped>
.repayment-info-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.text-lift{
  width: 220px;
  margin-right: 18px;
  color: #1D3A71;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.text-right{
  word-break: normal;
  width: 450px;
  color: #1C1C1C;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.form-item {
  margin-right:  20px;
  display: flex;
  align-items: center;
}
.ml-20 {
  margin-left: 20px;
}
</style>
